export const sendEvent = <E extends unknown>(event: E) => {
    const doSend = globalThis.window.DECO.events.dispatch

    if (typeof doSend === 'function') {
        return doSend(event)
    }

    console.info(
        'Cannot find Analytics section in your page. Press `.` to add Analytics and supress this warning',
    )
}
